import { parseTime, parseTimerOptions } from "../support/helpers";
import createTimer from "./timer";

import {
  appendToArray,
  isFunction,
  isPlainObject,
  objectWithAccessors,
  removeFromArray,
  withProperties
} from "../../utils";

export default function createCountdownTimer(options) {
  function __timerFactory__(options) {
    const $this = isPlainObject(this) ? this : {};

    return createTimer({
      tick({ current, duration }) {
        return current <= duration;
      },

      updater({ current, duration }) {
        const time = parseTime(duration - current);
        $this.callbacks && $this.callbacks.forEach(callback => callback(time));
      }
    })(options);
  }

  createCountdownTimer = function createCountdownTimer(options) {
    let callback, $callbacks = [];
    
    ({ callback, ...options } = parseTimerOptions(options));
    options = { ...options, callback: modifiedCallback };

    const created = __timerFactory__.call(objectWithAccessors({
      callbacks: () => $callbacks
    }), options);

    if (isPlainObject(created)) {
      return withProperties(created, {
        addTickCallback(cb) {
          const isCallback = isFunction(cb);
          return (isCallback && ($callbacks = appendToArray($callbacks, cb)), isCallback);
        },

        removeTickCallback(cb) {
          const isCallback = $callbacks && $callbacks.indexOf(cb) >= 0;
          return (isCallback && ($callbacks = removeFromArray($callbacks, cb)), isCallback);
        }
      });
    }

    function modifiedCallback() {
      ($callbacks.length = 0, $callbacks = undefined);
      callback();
    }

    return null;
  }

  return createCountdownTimer(options);
}
